import { render, staticRenderFns } from "./PackageViewGallery.vue?vue&type=template&id=3db80326"
import script from "./PackageViewGallery.vue?vue&type=script&lang=js"
export * from "./PackageViewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports